import axios from 'axios';


export async function httpGet<T>(url: string): Promise<T> {
  return (await axios.get(url)).data;
}

/* 
              
             
              
                
 */
export async function httpPost<T>(url: string, body: any, config?: any): Promise<T> {
  return (await axios.post(url, body, config)).data;
}

export async function httpDelete<T>(url: string): Promise<T> {
  return (await axios.delete(url)).data;
}
